export default class ClientConstants 
{
    public static  IDENTITY = "https://api-dev.flyx2.cloud/identity";
    public static  CLIENT_PRIMARY_COLOR = "#005e53";
    public static  CLIENT_NAME = "Lunch Garden";
    public static  CLIENT_IMAGE = "https://upload.wikimedia.org/wikipedia/fr/thumb/4/4a/Logo_Lunch_Garden.svg/1200px-Logo_Lunch_Garden.svg.png";
    public static ROUND_CLIENT_IMAGE = true;
}